import { Debt } from '../../interfaces';
import { getAllOpenHouseholdDebtsByAccountTypes } from './getAllOpenHouseholdDebtsByAccountTypes';

export const AUTO_LOAN_ACCOUNT_TYPES = ['AL', 'AU'];

export const getAllHouseholdAutoLoans = (borrowerDebts: Debt[] = [], spouseDebts: Debt[] = []): Debt[] =>
  getAllOpenHouseholdDebtsByAccountTypes(borrowerDebts, spouseDebts, AUTO_LOAN_ACCOUNT_TYPES);
